import * as React from 'react';
import './Capacity.scss';

interface CapacityProps {
  number?: number;
}

const Dot = () => {
  return <div className='capacity-dot' />;
};

export const Capacity = ({ number }: CapacityProps) => {
  if (!number) {
    return null;
  }

  const half = Math.ceil(number / 2);

  return (
    <div className='capacity-container'>
      {new Array(number)
        .fill(number)
        .map((_, i) => [
          <Dot key={i} />,
          number > 2 && half === i + 1 && <div key={`break-${i}`} className='capacity-break' />,
        ])}
    </div>
  );
};
